import WcIcon from '@material-ui/icons/Wc';
export const GeslachtIcon = WcIcon;

